import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import ProfileTableItem from "../../ProfileTableItem"
import classNames from "classnames"
import styles from "./FreelancerDescription.module.scss"
import CopyToClipboard from "../../../CopyToClipboard"

const FreelancerDescription = ({
  data,
  title = "About Freelancer",
  headerAction,
}) => {
  const hasContent = data && String(data).trim().length > 0
  const [isExpanded, setIsExpanded] = useState(false)
  const maxLines = 5
  const lines = useMemo(
    () => (hasContent ? String(data).split("\n") : []),
    [data, hasContent],
  )
  const isClamped = lines.length > maxLines
  const visibleText = isExpanded
    ? String(data)
    : lines.slice(0, maxLines).join("\n")

  useEffect(() => {
    setIsExpanded(false)
  }, [data])

  return (
    <div>
      {headerAction ? (
        <>
          <div className={styles.shareRow}>
            <div className={styles.headerAction}>{headerAction}</div>
          </div>
          <div className={styles.titleRow}>
            <h5 className={styles.headerTitle}>{title}</h5>
            <span className={styles.headerLine} />
          </div>
        </>
      ) : (
        <ProfileTableItem
          title={title}
          hasData={!!hasContent}
          anotherUser={true}
        />
      )}
      <div
        className={classNames({
          [styles.wrapper]: data,
          [styles.hiddenWrapper]: !data,
        })}
      >
        <div className={styles.content}>
          <div className={styles.contentText}>
            <CopyToClipboard text={hasContent ? visibleText : "—"} />
          </div>
          {hasContent && (isClamped || isExpanded) ? (
            <button
              type="button"
              className={styles.toggleButton}
              onClick={() => setIsExpanded((prev) => !prev)}
            >
              {isExpanded ? "Show less" : "Show more"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}

FreelancerDescription.propTypes = {
  data: PropTypes.string,
}

FreelancerDescription.defaultProps = {
  data: "",
}

export default FreelancerDescription
